export const fromWei = (value: number): string =>
  Math.floor(value * 10 ** -18).toLocaleString("jp-JP");
